"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HierarchyAssemblerImpl = void 0;
var HierarchyAssembler_1 = require("./HierarchyAssembler");
var HierarchyAssemblerImpl = /** @class */ (function () {
    function HierarchyAssemblerImpl() {
    }
    HierarchyAssemblerImpl.prototype.assembleChildren = function (rootItem, content) {
        var _a;
        var _this = this;
        (_a = rootItem.children).push.apply(_a, content
            .filter(function (contentItem) {
            return (0, HierarchyAssembler_1.isParent)(rootItem.content, contentItem.content);
        })
            .map(function (item) {
            var hierarchyItem = {
                content: item.content,
                children: [],
            };
            _this.assembleChildren(hierarchyItem, content);
            return hierarchyItem;
        }));
    };
    HierarchyAssemblerImpl.prototype.assembleRoot = function (rootItem, content) {
        var _this = this;
        var rootHierarchyItem = {
            content: rootItem.toJSON(),
            children: [],
        };
        rootHierarchyItem.children = content
            .filter(function (contentItem) {
            return (0, HierarchyAssembler_1.isParent)(rootItem.body, contentItem.content);
        })
            .map(function (item) {
            var hierarchyItem = {
                content: item.content,
                children: [],
            };
            _this.assembleChildren(hierarchyItem, content);
            return hierarchyItem;
        });
        return rootHierarchyItem;
    };
    return HierarchyAssemblerImpl;
}());
exports.HierarchyAssemblerImpl = HierarchyAssemblerImpl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSGllcmFyY2h5QXNzZW1ibGVySW1wbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uLy4uL3NyYy9saWIvY29udGVudC9jb29yZGluYXRvcnMvR2V0QnlIaWVyYXJjaHkvYXNzZW1ibGVycy9IaWVyYXJjaHlBc3NlbWJsZXJJbXBsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUNBLDJEQUFvRTtBQU9wRTtJQUFBO0lBNkNBLENBQUM7SUEzQ0MsaURBQWdCLEdBQWhCLFVBQ0UsUUFBb0MsRUFDcEMsT0FBeUM7O1FBRjNDLGlCQWtCQztRQWRDLENBQUEsS0FBQSxRQUFRLENBQUMsUUFBUSxDQUFBLENBQUMsSUFBSSxXQUNqQixPQUFPO2FBQ1AsTUFBTSxDQUFDLFVBQUMsV0FBVztZQUNsQixPQUFPLElBQUEsNkJBQVEsRUFBQyxRQUFRLENBQUMsT0FBTyxFQUFFLFdBQVcsQ0FBQyxPQUFPLENBQUMsQ0FBQztRQUN6RCxDQUFDLENBQUM7YUFDRCxHQUFHLENBQUMsVUFBQyxJQUFJO1lBQ1IsSUFBTSxhQUFhLEdBQThCO2dCQUMvQyxPQUFPLEVBQUUsSUFBSSxDQUFDLE9BQU87Z0JBQ3JCLFFBQVEsRUFBRSxFQUFFO2FBQ2IsQ0FBQztZQUNGLEtBQUksQ0FBQyxnQkFBZ0IsQ0FBQyxhQUFhLEVBQUUsT0FBTyxDQUFDLENBQUM7WUFDOUMsT0FBTyxhQUFhLENBQUM7UUFDdkIsQ0FBQyxDQUFDLEVBQ0o7SUFDSixDQUFDO0lBRUQsNkNBQVksR0FBWixVQUNFLFFBQTJCLEVBQzNCLE9BQXlDO1FBRjNDLGlCQXNCQztRQWxCQyxJQUFNLGlCQUFpQixHQUErQjtZQUNwRCxPQUFPLEVBQUUsUUFBUSxDQUFDLE1BQU0sRUFBRTtZQUMxQixRQUFRLEVBQUUsRUFBRTtTQUNiLENBQUM7UUFDRixpQkFBaUIsQ0FBQyxRQUFRLEdBQUcsT0FBTzthQUNqQyxNQUFNLENBQUMsVUFBQyxXQUFXO1lBQ2xCLE9BQU8sSUFBQSw2QkFBUSxFQUFDLFFBQVEsQ0FBQyxJQUFJLEVBQUUsV0FBVyxDQUFDLE9BQU8sQ0FBQyxDQUFDO1FBQ3RELENBQUMsQ0FBQzthQUNELEdBQUcsQ0FBQyxVQUFDLElBQUk7WUFDUixJQUFNLGFBQWEsR0FBK0I7Z0JBQ2hELE9BQU8sRUFBRSxJQUFJLENBQUMsT0FBTztnQkFDckIsUUFBUSxFQUFFLEVBQUU7YUFDYixDQUFDO1lBQ0YsS0FBSSxDQUFDLGdCQUFnQixDQUFDLGFBQWEsRUFBRSxPQUFPLENBQUMsQ0FBQztZQUM5QyxPQUFPLGFBQWEsQ0FBQztRQUN2QixDQUFDLENBQUMsQ0FBQztRQUVMLE9BQU8saUJBQWlCLENBQUM7SUFDM0IsQ0FBQztJQUNILDZCQUFDO0FBQUQsQ0FBQyxBQTdDRCxJQTZDQztBQTdDWSx3REFBc0IifQ==